import {Component} from '@angular/core';

export const ACCOUNT_ICON_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fill-rule="evenodd">
            <path d="M0 0h24v24H0z"/>
            <path fill="#9E9E9E" d="M21.92 11.245V7.39a2.123 2.123 0 0 0-2.13-2.11h-1.444l-1.476-2.63a1.281 1.281 0 0 0-1.74-.491L9.465 5.28H4.13A2.122 2.122 0 0 0 2 7.396v12.49A2.123 2.123 0 0 0 4.13 22h15.66a2.122 2.122 0 0 0 2.13-2.115V16.63h1.066V11.25l-1.066-.004zm-2.13-5.12a1.269 1.269 0 0 1 1.268 1.125h-1.606l-.632-1.126h.97zm-4.245-3.228a.436.436 0 0 1 .579.165l2.352 4.188H7.64l7.905-4.353zm4.245 18.249H4.13a1.274 1.274 0 0 1-1.278-1.269V7.391a1.274 1.274 0 0 1 1.279-1.268h3.798L5.885 7.248H4.397a.423.423 0 0 0 0 .846h16.674v3.15h-3.12a2.617 2.617 0 0 0-2.621 2.6v.182a2.616 2.616 0 0 0 2.621 2.599h3.117v3.255a1.276 1.276 0 0 1-1.278 1.266zm2.343-5.364H17.95a1.767 1.767 0 0 1-1.776-1.756v-.181c.006-.975.801-1.761 1.776-1.756h4.183v3.693h-.001zm-2.875-1.812a.941.941 0 1 1-1.881.022.941.941 0 0 1 1.88-.022z"/>
        </g>
    </svg>
`;

@Component({
    selector: 'tfl-account-icon',
    template: ACCOUNT_ICON_SVG
})
export class AccountIcon {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/account.icon.ts